module.exports = __webpack_public_path__ + "static/media/app-store-google-play.d65d3d6a.png";